import {BANNED_WORDS} from '@/lib/constants/bannedWords';

export const validateTextInput = (value: string, fieldName: string, minLength = 2, maxLength = 50) => {
  if (!value) return `${fieldName} is required.`;
  if (value.length < minLength) return `${fieldName} must be at least ${minLength} characters.`;
  if (value.length > maxLength) return `${fieldName} must be at most ${maxLength} characters.`;
  if (BANNED_WORDS.includes(value.toLowerCase())) return `Invalid ${fieldName.toLowerCase()}.`;
  if (!/^[a-zA-Z\s'-]+$/.test(value)) return `${fieldName} can only contain letters, spaces, apostrophes, and hyphens.`;
  return true;
};
